<template>
  <div class="elevation-1 pa-1" style="margin-bottom: 16px; margin-left: 2px;">
    <v-layout row wrap v-for="lang in val" :key="lang.lang">
      <v-flex :style="{'align-self': (multiLine || markdown ? 'flex-end' : 'initial')}" xs1>
        <v-select v-bind:items="languages" v-model="lang.lang" label="" :disabled="languagesIsEmpty"></v-select>
      </v-flex>
      <v-flex xs9>
        <MarkDown
          v-if="markdown"
          v-model="lang.value"
          :label="label || title"
          style="margin-left: 10px;"
        ></MarkDown>
        <v-textarea
          v-else-if="multiLine"
          v-model="lang.value"
          :label="label || title"
        ></v-textarea>
        <v-text-field
          v-else
          v-model="lang.value"
          :label="label || title"
        ></v-text-field>

      </v-flex>
      <v-flex xs2 class="text-xs-right">
        <v-btn color="error" fab flat @click.stop="removeLanguage(lang.lang)" :disabled="removeDisabled"><v-icon>delete</v-icon></v-btn>
      </v-flex>
      <v-flex xs12><v-divider></v-divider></v-flex>
    </v-layout>
    <div class="text-xs-right">
      <v-btn color="info" small :disabled="languagesIsEmpty" @click="addLanguage">Add language</v-btn>
    </div>
  </div>
</template>

<script>
import MarkDown from "@/components/MarkDown"
export default {
  components: {
    MarkDown
  },
  props: {
    'value': {
      type: Object,
      default () { return {}; }
    },
    'languages': {
      type: Array,
      default () { return []; }
    },
    'default_language': {
      type: String,
      default: "en"
    },
    'label': String,
    'title': String,
    'name': String,
    'multi-line': {
      type: Boolean,
      default: false
    },
    'markdown': {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.val.length == 0 && this.languages.indexOf(this.default_language) != -1) {
        this.val.push({"lang": this.default_language, "value": ""})
      }
    })

  },
  computed: {
    languagesIsEmpty () {
      return this.usedLanguages.length == 0;
    },
    removeDisabled () {
      if (this.val.length == 1) return true;
      return false;
    },
    usedLanguages () {
      var usedLangs = this.val.map((item) => { return item.lang; });
      return this.languages.filter((item) => {
        return usedLangs.indexOf(item) == -1;
      });
    },
    val: {
      get () {
        var val = _.get(this.value, this.name);
        if(typeof(val) != "object") {
          this.val = [];
          return [];
        }
        return val;
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  },
  methods: {
    removeLanguage(lang) {
      var list = _.cloneDeep(this.val);
      _.remove(list, function(t) { if (t.lang == lang) return true;
        return false;
      });
      this.val = list;
    },
    addLanguage() {
      this.val.push({lang: this.usedLanguages[0]||this.default_language, value: ""});
    }
  }
}
</script>
